import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';

export const FdicIcon = () => {
  const {t} = useTranslation();

  return (
    <>
      <Box
        component="img"
        src="/assets/icons/security_tick.svg"
        alt="secure tick"
        className="w-[29px] h-[29px] text-on-surface-variant"
      />
      {t('split_bills_page.landing.fdic_insured')}
    </>
  );
};
